import { setSettingForApp } from 'entities/user/module/app-settings'
import userStore from 'entities/user/module/user-store'

import {
  Minute,
  RestoreFormProps,
  SavedFormKeys,
  SavedFormKeysTypes,
} from 'shared/hooks'

export const saveForm = <T extends object>(
  data: T,
  key: SavedFormKeysTypes,
) => {
  const currentTimeInMinutes = Math.floor(Date.now() / Minute)

  void setSettingForApp({ key, value: JSON.stringify(data) })
  void setSettingForApp({
    key: SavedFormKeys[key].value,
    value: currentTimeInMinutes.toString(),
  })
}

export const checkTimeOnSavedForm = (
  key: SavedFormKeysTypes,
  duration: number,
): boolean => {
  const lastHiddenTime = userStore.getClientStateString(
    SavedFormKeys[key].value,
  )

  if (!Boolean(lastHiddenTime?.length)) return true

  const currentTimeInMinutes = Math.floor(Date.now() / Minute)
  const timeDifference = currentTimeInMinutes - parseInt(lastHiddenTime, 10)
  const isOld = timeDifference > duration

  if (isOld) {
    void setSettingForApp({ key: SavedFormKeys[key].value, value: '' })
  }

  return isOld
}

export const getFormFromLocalStorage = <T = unknown>(
  key: SavedFormKeysTypes,
): T | null => {
  const formData = userStore.getClientStateString(key)

  if (!Boolean(formData?.length)) return null

  try {
    return JSON.parse(formData) as T
  } catch {
    return null
  }
}

export const restoreFormData = <T>({
  key,
  duration,
  setter,
}: RestoreFormProps<T>) => {
  if (checkTimeOnSavedForm(key, duration)) return

  const savedFormData = getFormFromLocalStorage<T>(key)

  if (savedFormData) setter(savedFormData)
}
